import React from "react";
import "./skills.css";

const Passiva = () => {
  return (
    <>
      <iframe
        src="https://d28xe8vt774jo5.cloudfront.net/champion-abilities/0080/ability_0080_P1.webm"
        title="Passiva"
        className="video"
      />
    </>
  );
};

export default Passiva;
